import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type pgalCredType = (typeof credentialTypes)[number]
export const pgal: CarrierDef<pgalCredType> = {
  name: 'PGA Delivery Service LLC',
  scac: 'pgal',
  credentialTypes,
  legacyCredMap: [...userPassMap],
  engineLayers: [],
}
